import { Col, Row } from "react-bootstrap"
import React, { FC, useEffect } from "react"

type Props = {
  country?: string
  onChangeCountry?: (e: React.ChangeEvent<HTMLInputElement>) => any
}

const ContactUs: FC<Props> = () => {
  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://js.hsforms.net/forms/v2.js"
    document.body.appendChild(script)

    script.addEventListener("load", () => {
      // @TS-ignore
      if (window.hbspt) {
        // @TS-ignore
        window.hbspt.forms.create({
          region: "na1",
          portalId: "20251404",
          formId: "319b436e-ab22-4ac5-98f8-d02b62c140a7",
          target: "#hubspotForm",
          css: "",
          cssClass: "",
        })
      }
    })
  }, [])

  return (
    <Row>
      <Col xs={12} sm={{ span: 10, offset: 1 }}>
        <div id="hubspotForm"></div>
      </Col>
    </Row>
  )
}

export default ContactUs
